import { VueModule } from '@Foundation/utilities';
import Faq from './code/Scripts/components/faq';

export default VueModule({
  components: {
    Faq
  }
});
